import { inject, signal, WritableSignal } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';

export class NewValueAccessor<T> implements ControlValueAccessor {
  readonly _value: WritableSignal<T | null> = signal<T | null>(null);
  readonly _disabledByCva: WritableSignal<boolean> = signal(false);
  ngControl: NgControl = inject(NgControl, { optional: true, self: true });
  private isInterventionEnabled: boolean = false;

  onTouchedCallback: () => void =  (): void => {};
  onChangeCallback: (_: unknown) => void =  (): void => {};

  constructor() {
    if (this.ngControl != null) {
      this.ngControl.valueAccessor = this;
    }
  }

  // get accessor
  get value(): T {
    return this._value();
  }

  // set accessor
  set value(v: T) {
    if (v !== this._value()) {
      this._value.set(v);
      this.onChangeCallback(v);
    }
  }

  // Switch this on if you want to trigger the onChangeCallback
  // when the value is set by writeValue.
  // This is useful for cases where the value is set programmatically,
  // and you want to trigger change detection or other side effects.
  enableIntervention(): void {
    this.isInterventionEnabled = true;
  }

  // From ControlValueAccessor interface
  writeValue(value: T): void {
    if (value !== this._value()) {
      this._value.set(value);
      if (this.isInterventionEnabled) {
        this.onChangeCallback(value);
      }
    }
  }

  // From ControlValueAccessor interface
  registerOnChange(fn: () => unknown): void {
    this.onChangeCallback = fn;
  }

  // From ControlValueAccessor interface
  registerOnTouched(fn: () => unknown): void {
    this.onTouchedCallback = fn;
  }

  // From ControlValueAccessor interface
  setDisabledState(isDisabled: boolean): void {
    this._disabledByCva.set(isDisabled);
  }
}
